import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';

import metadata from './ProductandcoveragesselectionComponent.metadata.json5';
import styles from '../../../pages/Commercial/CommercialPage.module.scss';

function ProductandcoveragesselectionComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('ProductandcoveragesselectionComponent');
    const modelVM = _.get(submissionVM, pathUpdated)

    modelVM.value.isValidationReq = true

    const isVisibleAnyCheckboxSelected = () => (!_.isUndefined(modelVM.value.recaclaorcomregprsecFie) && modelVM.value.recaclaorcomregprsecFie)
            || (!_.isUndefined(modelVM.value.beeSubToAnyGovOrRegInvReg) && modelVM.value.beeSubToAnyGovOrRegInvReg)
            || (!_.isUndefined(modelVM.value.recAComOrCeaAndDesDemAkkInt) && modelVM.value.recAComOrCeaAndDesDemAkkInt)
            || (!_.isUndefined(modelVM.value.notAnyPerOfAPrivVioAndOrBreInc) && modelVM.value.notAnyPerOfAPrivVioAndOrBreInc)
            || (!_.isUndefined(modelVM.value.recAnExtDemRelToYouDatAndOrCom) && modelVM.value.recAnExtDemRelToYouDatAndOrCom)
            || (!_.isUndefined(modelVM.value.expANetOutThaResInASigDis) && modelVM.value.expANetOutThaResInASigDis)

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        proTypFie: {
            readOnly: true
        },
        cybLiaFie: {
            readOnly: true
        },
        ifyespleprodetFie: {
            visible: !_.isUndefined(modelVM.value.hasanyinsevecandecforFie) && modelVM.value.hasanyinsevecandecforFie
        },
        ifyespleDesFie: {
            visible: !_.isUndefined(modelVM.value.havthebeeanychainoopeFie) && modelVM.value.havthebeeanychainoopeFie
        },
        ifYouHavAnsYesToAnyOfTheAboPleProvDetaIn: {
            visible: isVisibleAnyCheckboxSelected()
        }
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

ProductandcoveragesselectionComponent.propTypes = wizardProps;
export default withRouter(ProductandcoveragesselectionComponent);
